import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { user, profile, loading, logout } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div className="p-4 text-center">Carregando…</div>
  }

  if (!user) {
    return <Navigate to="/pwa/auth" replace state={{ from: location.pathname }} />
  }

  // Conta nova só entra depois da aprovação, como na versão de computador
  if (profile && profile.status !== 'ACTIVE') {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-semibold">{profile.status === 'INACTIVE' ? 'Acesso não autorizado' : 'Conta em análise'}</h1>
        <p className="text-sm text-slate-600">
          {profile.status === 'INACTIVE'
            ? 'Esta conta não tem acesso ao sistema.'
            : 'Sua conta foi criada e está aguardando a aprovação do escritório.'}
        </p>
        <button type="button" onClick={logout} className="rounded-xl border border-slate-300 px-4 py-2 text-sm">Sair</button>
      </div>
    )
  }

  return <>{children}</>
}
